import { ReservationAttributes } from '@/types/embed';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type CartState = ReservationAttributes & {
  reservationEndTime: number;
};

const initialState: CartState = {
  reserved: '',
  bundle_count: 0,
  items_count: 0,
  product_count: 0,
  ticket_count: 0,
  time_remaining: 0,
  reservationEndTime: 0,
};

const reservationSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    setReservation: (
      state,
      { payload }: PayloadAction<ReservationAttributes>,
    ) => ({
      ...state,
      bundle_count: payload.bundle_count,
      items_count: payload.items_count,
      ticket_count: payload.ticket_count,
      product_count: payload.product_count,
      reserved: payload.reserved,
      time_remaining: payload.time_remaining,
      reservationEndTime: new Date().getTime() + payload.time_remaining * 1000,
    }),
    clearReservation: () => initialState,
  },
});

export const { setReservation, clearReservation } = reservationSlice.actions;

export default reservationSlice.reducer;
